import UIDivider, { DividerProps } from '@material-ui/core/Divider';
import cn from 'classnames';
import styles from './index.module.pcss';

export const Divider = ({ className = '', ...props }: DividerProps) => (
	<UIDivider classes={{ root: cn(styles.root, className) }} {...props} />
);
